<script lang="ts">
	import * as Drawer from '$lib/components/ui/drawer';
	import { buttonVariants } from '$lib/components/ui/button';
	import { siteConfig } from '$lib/config/site';
	import { cn } from '$lib/utils.js';
	import { Menu } from 'lucide-svelte';
	import { bookDemo } from '$lib/state/global.svelte';
	import { mode } from '$lib/state/global.svelte';
	import { page } from '$app/state';

	let open = $state(false);
	let { navigation: _navigation } = $props();

	let navigation = $derived([
		..._navigation,
		{ title: 'Get a demo', path: 'bookDemo', variant: 'outline' },
		{ title: 'Start for free', path: 'signup' },
		{ title: 'Login', path: siteConfig.links.login, variant: 'outline' }
	]);

	type ListItemProps = {
		className?: string;
		variant?: string;
		title: string;
		href: string;
		content: string;
	};
</script>

{#snippet ListItem({ className, title, href }: ListItemProps)}
	<li class="w-1/2 p-1">
		<a
			class={cn(
				buttonVariants({ variant: 'secondary' }),
				'flex w-full items-center justify-center text-center font-semibold',
				className,
				page.url.pathname === href ? 'font-semibold underline' : ''
			)}
			{href}
			onclick={() => (open = false)}
		>
			{title}
		</a>
	</li>
{/snippet}

<Drawer.Root bind:open>
	<Drawer.Trigger>
		<Menu class="!h-[38px] !w-[38px]" />
	</Drawer.Trigger>
	<Drawer.Content>
		<a href="/" class="flex w-full justify-center pt-4" onclick={() => (open = false)}>
			{#if $mode === 'dark'}
				<img alt="MVMNT" src={siteConfig.darkLogo} class="w-[140px]" />
			{:else}
				<img alt="MVMNT" src={siteConfig.lightLogo} class="w-[140px]" />
			{/if}
		</a>
		<div class="flex flex-col space-y-2 p-2">
			{#each navigation as nav}
				{#if nav.items?.length}
					<div>
						<div class="mb-2 flex items-end justify-center text-center text-xl">
							{nav.title}
						</div>
						<div>
							<ul class="flex flex-row flex-wrap text-center text-lg">
								<!-- <li class="row-span-3"> -->
								<!-- 	<NavigationMenu.Link -->
								<!-- 		href="/" -->
								<!-- 		class="flex h-full w-full select-none flex-col justify-end rounded-md bg-gradient-to-b from-muted/50 to-muted p-6 no-underline outline-none focus:shadow-md" -->
								<!-- 	> -->
								<!-- 		<Icons.logo class="h-6 w-6" /> -->
								<!-- 		<div class="mb-2 mt-4 text-lg font-medium">MVMNT</div> -->
								<!-- 		<p class="text-sm leading-tight text-muted-foreground"> -->
								<!-- 			The best TMS for brokers. -->
								<!-- 		</p> -->
								<!-- 	</NavigationMenu.Link> -->
								<!-- </li> -->
								{#each nav.items as item}
									{@render ListItem({
										href: item.externalPath ?? `/${item.path}`,
										title: item.title
									})}
								{/each}
							</ul>
						</div>
					</div>
				{:else}
					<a
						class={cn(
							buttonVariants({ variant: nav.variant ?? 'default' }),
							'flex w-full items-center justify-center gap-2 text-center font-semibold'
						)}
						href={nav.path === 'bookDemo' ? '#' : `/${nav.path}`}
						onclick={() => {
							if (nav.path === 'bookDemo') {
								bookDemo();
							}
							open = false;
						}}
					>
						{nav.title}
					</a>
				{/if}
			{/each}
		</div>
	</Drawer.Content>
</Drawer.Root>

<!-- <Sheet.Content side="left" class="pr-0"> -->
<!-- 	<MobileLink href="/" class="flex items-center" bind:open> -->
<!-- 		<!-- <Icon.Logo class="mr-2 size-4" /> -->
<!-- 		<span class="font-bold">{siteConfig.name}</span> -->
<!-- 	</MobileLink> -->
<!-- 	<ScrollArea orientation="both" class="my-4 h-[calc(100vh-8rem)] pb-10 pl-6"> -->
<!-- 		<div class="flex flex-col space-y-3"> -->
<!-- 			{#each docsConfig.mainNav as navItem, index (navItem + index.toString())} -->
<!-- 				{#if navItem.href} -->
<!-- 					<MobileLink href={navItem.href} bind:open class="text-foreground"> -->
<!-- 						{navItem.title} -->
<!-- 					</MobileLink> -->
<!-- 				{/if} -->
<!-- 			{/each} -->
<!-- 		</div> -->
<!-- 		<div class="flex flex-col space-y-2"> -->
<!-- 			{#each docsConfig.sidebarNav as navItem, index (index)} -->
<!-- 				<div class="flex flex-col space-y-3 pt-6"> -->
<!-- 					<h4 class="font-medium">{navItem.title}</h4> -->
<!-- 					{#if navItem?.items?.length} -->
<!-- 						{#each navItem.items as item} -->
<!-- 							{#if !item.disabled && item.href} -->
<!-- 								<MobileLink href={item.href} bind:open> -->
<!-- 									{item.title} -->
<!-- 									{#if item.label} -->
<!-- 										<span -->
<!-- 											class="ml-2 rounded-md bg-[#adfa1d] px-1.5 py-0.5 text-xs leading-none text-[#000000] no-underline group-hover:no-underline" -->
<!-- 										> -->
<!-- 											{item.label} -->
<!-- 										</span> -->
<!-- 									{/if} -->
<!-- 								</MobileLink> -->
<!-- 							{/if} -->
<!-- 						{/each} -->
<!-- 					{/if} -->
<!-- 				</div> -->
<!-- 			{/each} -->
<!-- 		</div> -->
<!-- 	</ScrollArea> -->
<!-- </Sheet.Content> -->
